module.exports = __webpack_public_path__ + "static/media/p-content-2.20699ae2.png";